export default "__VITE_ASSET__jcX5Ws5L__"